import { findAllSubjects } from '@src/main/modules/messages/application/use-cases/find/find-all-subjects.usecase';
import { SubjectRepository } from '@src/main/modules/messages/domain/subject/subject.repository';
import { createSubjectHttpRepository } from '@src/main/modules/messages/infrastructure/repository/SubjectHttpRepository';
import { useAuth } from '@src/main/shared/context/AuthContext';
import { useQuery } from '@tanstack/react-query';
import { useCallback, useEffect, useMemo, useState } from 'react';

export const useSubjects = () => {
  const { user } = useAuth();
  const [repository, setRepository] = useState<SubjectRepository | null>(null);

  const getToken = useCallback(async () => user?.token ?? '', [user?.token]);

  const tokenProvider = useMemo(() => ({ getToken }), [getToken]);

  useEffect(() => {
    if (user?.token) {
      const repo = createSubjectHttpRepository(tokenProvider);
      setRepository(repo);
    } else {
      setRepository(null);
    }
  }, [user?.token, tokenProvider]);

  const queryResult = useQuery({
    queryKey: ['subject'],
    queryFn: async () => {
      if (!repository) throw new Error('Repository not available');
      return await findAllSubjects(repository);
    },
    enabled: !!repository,
    staleTime: 1000 * 60,
  });

  return { ...queryResult, repository };
};
